import { PropsWithChildren, useEffect } from 'react';
import { useGlobalDispatch, useGlobalState } from '../../common/context/AppContext';
import { IAppProps } from '../../common/interface/IAppProvider';
import { GridWrapper } from '@flos/react-components';
import { HouseholdText } from './HouseholdText';
import { HouseholdForm } from './HouseholdForm';

export default function HouseholdScreenView(props: PropsWithChildren<IAppProps>): JSX.Element {
    const content = props.config.resourceBundles['onsa.travel.household'].read();
    const { initialState } = useGlobalState();
    const appDispatch = useGlobalDispatch();

    useEffect(() => {
        // resets state
        if (initialState) {
            appDispatch({ initialState: false });
        }
    }, [appDispatch, initialState]);

    return (
        <GridWrapper header={content.header}>
            <HouseholdText {...props} />
            <HouseholdForm appConfig={props.config} />
        </GridWrapper>
    );
}
